
import {
  RoomSelectPicker,
} from "components/js_selectpicker/room_selectpicker"
import {
  InputSelector as BaseInputSelector,
  Selector as BaseSelector,
} from "components/js_selectpicker/base"


type Selector = BaseSelector & {
  container: string
}

type InputSelector = BaseInputSelector & {
  container?: string
}

const default_selector = {
  scope:        ".cell--serviced-apartments--searches--filter-bar--sort__wrapper",
  main:         ".cell--serviced-apartments--searches--filter-bar--sort",
  arrow:        ".select2-selection__arrow b[role=\"presentation\"]",
  first_option: "option:nth-of-type(1)",
  container:    ".select2-container",
}


export class SortSelect extends RoomSelectPicker {
  protected selector: Selector

  protected $container: JQuery

  constructor(selector?: InputSelector) {
    const merged_selector = Object.assign({}, default_selector, selector)

    super(merged_selector)
    this.selector = merged_selector

    this.$container = this.$scope.find(this.selector.container)
  }

  protected extra_select2_options(): Select2.Options {
    // https://stackoverflow.com/a/35895710/838346
    return {
      dropdownAutoWidth: true,
      width:             "auto",
    }
  }
}


const Factory = {
  create(selector?: InputSelector){
    return new SortSelect(selector)
  },
}

export {
  Factory,
}
